import { Route, Routes } from 'react-router-dom';

import { TaxReturnCreatePage } from './pages/TaxReturnCreatePage';
import { TaxReturnListPage } from './pages/TaxReturnListPage';
import { TaxReturnSurccessPage } from './pages/TaxReturnSurccessPage';
import { TaxReturnTaxPeriodPage } from './pages/TaxReturnTaxPeriodPage';
import { ViewTaxReturnPage } from './pages/ViewTaxReturn/ViewTaxReturnPage';

export const TaxReturnRouting = () => {
  return (
    <>
      <Routes>
        <Route path="tax-period" element={<TaxReturnTaxPeriodPage />} />
        <Route path="list" element={<TaxReturnListPage />} />
        <Route path="view/:id" element={<ViewTaxReturnPage />} />
        <Route path="record/success/:id" element={<TaxReturnSurccessPage />} />
        <Route path="create/form/:version" element={<TaxReturnCreatePage />} />
      </Routes>
    </>
  );
};
